var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconDollar = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 18",
  width: "1em",
  height: "1em"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M16 9A7 7 0 1 1 2 9a7 7 0 0 1 14 0Zm2 0A9 9 0 1 1 0 9a9 9 0 0 1 18 0Zm-8-5a1 1 0 1 0-2 0v.705C6.888 5.005 6 5.844 6 7c0 .903.478 1.527 1.003 1.944.452.359 1.022.63 1.472.843l.095.045c.522.25.898.44 1.155.66.213.184.383.418.121.606-.192.139-.514.273-.93.307a2.764 2.764 0 0 1-1.469-.3 1 1 0 1 0-.894 1.79c.484.241.972.391 1.447.465V14a1 1 0 1 0 2 0v-.78a3.56 3.56 0 0 0 1.015-.5c.497-.357.985-.948.985-1.72 0-.912-.44-1.568-.974-2.026-.473-.405-1.038-.681-1.596-.947-.538-.256-.917-.438-1.183-.649-.118-.094-.321-.26-.227-.43a.5.5 0 0 1 .136-.15c.148-.113.414-.225.808-.211.292.01.66.093 1.089.307a1 1 0 1 0 .894-1.788A5.178 5.178 0 0 0 10 4.739V4Z",
  clipRule: "evenodd"
})));
export default SvgIconDollar;